<template>
  <div>
    <common-dialog ref="dialog" show-save-button width="850px" unit="设备APP" edit-title id-key="AppId"
      :data="data" form-label-width="80px" :form-rules="rules" :save-func="api.save" :get-data-func="api.info"
      close-on-saved @create-opened="onCreateOpened" @edit-opened="onEditOpened" @closed="onClosed"
      :before-save="onBeforeSave" @details-opened="onDetailsOpened" @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="版本号" prop="VersionNo">
              <el-input v-model="data.VersionNo" placeholder="版本号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="app文件" class="file-text is-required">
              <div class="text-box">
                <el-tooltip style="position: absolute;left: 25px;top: 7px;" effect="light" 
                  content="文件格式须为apk" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <el-upload
                  :action="host + '/api/Common/UploadFile'"
                  list-type="text"
                  :show-file-list="true"
                  :on-success="(res,file,fileList) => { onSuccess(res,file,fileList,'FileUrl') }"
                  accept=".apk"
                  :limit="1"
                  :headers="headers"
                  :file-list="FileUrl"
                  :on-preview="dlfile"
                  :on-exceed="onExceed"
                  :before-upload="beforeFileUpload"
                  :on-remove="($event) => { appRemove($event,'FileUrl') }">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import api from "@/api/op/app";
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
    },
    data() {
      return {
        data: {
          AppId: 0,
          VersionNo: "",
          FileUrl: "",
          Remark: null,
        },
        headers: { Authorization: "" },
        FileUrl: [],
        api,
        rules: {
          VersionNo: [{ required: true, message: "请填写版本号" }],
        },
      };
    },
    computed: {
      host() {
        return window.location.origin;
      }
    },
    methods: {
      onCreateOpened() {
        
      },
      onEditOpened(data) {
        this.FileUrl = [{ name: "下载.apk", url: '/api' + data.FileUrl, url2: data.FileUrl }];
      },
      onDetailsOpened(row) {
        this.onEditOpened(row)
      },
      beforePhotoUpload(file) {
        this.headers.Authorization = "Bearer " + localStorage.getItem("token");
      },
      onBeforeSave() {
        if(this.FileUrl.length==0) {
          this.$message.error("请上传apk");
          return false;
        } else {
          this.data.FileUrl = this.FileUrl[0].url2;
        }
      },
      beforeFileUpload(file) {
        this.headers.Authorization = "Bearer " + localStorage.getItem("token");
        return true;
      },
      onSuccess(res,file,fileList,name) {
        if(res.Code==0) {
          this[name].push({ name: "下载.apk", url: "/api" + res.Data.VirtualPath, url2: res.Data.VirtualPath })
        } else {
          fileList.splice(fileList.length-1,1);
          this.$message.error(res.Msg);
        }
      },
      onExceed() {
        this.$message.error("只能上传一个文件");
      },
      dlfile(file) {
        const elink = document.createElement("a");
        elink.download = file.name;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = this.host + file.url;
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      },
      appRemove(file,name) {
        this[name].forEach((e,i) => {
          if(e.url == file.url) {
            this[name].splice(i,1);
            return;
          }
        })
      },
      onClosed() {
        this.FileUrl = [];
      },
    },
  };
</script>
<style lang="scss" scoped>
.file-text{
  .el-form-item__label {
    line-height: 28px;
  }
}
</style>